"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userTag = exports.replies = void 0;

var _DynamicFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/DynamicFilterSelector"));

var _RadioInputFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/RadioInputFilterSelector"));

var _utils = require("@insided/deprecated-control/overview/filters/utils");

var userTag = function userTag() {
  return _DynamicFilterSelector.default.create({
    id: 'userTag',
    name: 'User tag',
    items: [],
    fetchUrl: '/contact/userTag?q='
  });
};

exports.userTag = userTag;

var replies = function replies() {
  return _RadioInputFilterSelector.default.create({
    id: 'replies',
    name: 'Replies',
    items: (0, _utils.getRangeSelectorItems)()
  });
};

exports.replies = replies;